import { TitleSection } from "../title-section";
import PieChart from "./pie-chart";

export const Pizzas: React.FC = () => {
  return (
    <section className="py-10 px-4 lg:px-0 flex justify-center">
      <div className="w-full lg:max-w-screen-md xl:max-w-screen-xl 2xl:max-w-screen-2xl">
        <TitleSection
          blueToRed={false}
          first_title="Assuntos de Humanas mais cobrados por matéria"
          description="Confira os temas mais cobrados nas provas de Humanas, organizados por matéria. Em História, destacam-se Brasil Colonial e Primeira República. Na Geografia, Urbanização e Agropecuária lideram os conteúdos. Filosofia enfatiza temas como Filosofia Política e Moral e Ética, enquanto Sociologia traz destaque para Direito, Cidadania e Movimentos Sociais, além de Cultura e Sociedade."
        />
        <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-3 gap-6">
          {/* <PieChart
            labels={[
              "Brasil Colonial",
              "Primeira República",
              "Era Vargas",
              "História Pública",
              "Ditadura Civil-Militar no Brasil",
            ]}
            values={[45, 31, 26, 22, 21]}
            title="História"
          /> */}
          <PieChart
            labels={[
              "Urbanização",
              "Agropecuária",
              "Desenvolvimento Econômico",
              "Ruralidade",
              "Geopolítica e relações internacionais",
            ]}
            values={[33, 32, 24, 23, 20]}
            title="Geografia"
          />
          <PieChart
            labels={[
              "Filosofia política",
              "Moral e ética",
              "Aristóteles",
              "Origens da Modernidade",
              "Descartes",
            ]}
            values={[20, 15, 10, 8, 8]}
            title="Filosofia"
          />
          <PieChart
            labels={[
              "Direito, cidadania e movimentos sociais",
              "Cultura e sociedade",
              "Identidade e diversidade",
              "Política e Estado",
              "Trabalho e sociedade",
            ]}
            values={[47, 24, 23, 23, 20]}
            title="Sociologia"
          />
        </div>
      </div>
    </section>
  );
};
